import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 264 107",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<rect x=\"32\" y=\"63\" width=\"200\" height=\"2\" rx=\"1\" fill=\"var(--dt-color-surface-moderate)\" id=\"bar\"></rect><rect x=\"32\" y=\"63\" width=\"56\" height=\"2\" rx=\"1\" fill=\"var(--dt-color-link-primary)\" id=\"activebar\"></rect><rect x=\"32\" y=\"43\" width=\"56\" height=\"12\" rx=\"6\" fill=\"var(--dt-color-link-primary)\" id=\"tab-active\"></rect><rect x=\"104\" y=\"43\" width=\"56\" height=\"12\" rx=\"6\" fill=\"var(--dt-color-surface-moderate)\" id=\"tab-inactive-two\"></rect><rect x=\"176\" y=\"43\" width=\"56\" height=\"12\" rx=\"6\" fill=\"var(--dt-color-surface-moderate)\" id=\"tab-inactive-three\"></rect>", 5)
  ]))]))
}
export default { render: render }